import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  margin: "40px 60px",
  padding: "40px 80px",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "4px",
  backgroundColor: theme.palette.background.paper,
}));

export const PaneWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  flex: 1,
  minWidth: 0,
}));

export const ActionColumn = styled(Box)(() => ({
  flex: "0 0 220px",
  alignSelf: "stretch",
}));

export const CategorySetBox = styled(Box)(({ theme }) => ({
  marginTop: "12px",
  minHeight: "420px",
  overflowY: "auto",
  padding: "8px",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "4px",
  backgroundColor: theme.palette.background.paper,
  overflowWrap: "anywhere",
}));

export const fieldStyles = {
  "& .MuiInputBase-input, & .MuiInputBase-input::placeholder": {
    fontSize: "14px",
    fontFamily: "Helvetica",
    fontWeight: 400,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "divider",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "text.primary",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline":
    {
      borderColor: "focusColor.main",
      borderWidth: "1.5px",
    },
  "& .MuiInputLabel-root.Mui-focused, & .MuiFormLabel-root.Mui-focused": {
    color: "focusColor.main",
  },
};

export const CategorySetRow = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "selected",
})<{ selected?: boolean }>(({ selected }) => ({
  fontWeight: selected ? 700 : 400,
  textAlign: "left",
  padding: "2px 4px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const StatusMessage = styled(Typography)(() => ({
  minHeight: "1.2em",
}));
